import React, { forwardRef } from 'react';
import clsx from 'clsx';

export const CardHeaderToolbar = forwardRef(
    ({ children, className, ...props }, ref) => (
        <div {...props} ref={ref} className={clsx('card-toolbar', className)}>
            {children}
        </div>
    )
);

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    CardHeaderToolbar.displayName = 'CardHeaderToolbar';
}
